module.exports = __webpack_public_path__ + "img/evacuvationcar-sq.08dff07d.svg";